import {
  PARENT_ROLES,
  SUB_ROLES,
  PRIVILEGES,
  SUB_ROLE_SEARCH,
  PARENT_ROLE_SEARCH,
  PRIVILEGE_SEARCH,
  ERROR_MESSAGE,
  ERROR_TITLE,
} from "../../utility/TextLabels";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import { useEffect, useState } from "react";
import Searchbar from "../../components/Searchbar/Searchbar";
import Paper from "../../components/Paper/Paper";
import ViewSelector from "../../components/ViewSelector/ViewSelector";
import ReportItem from "./ReportItem/ReportItem";
import React from "react";
import { Report } from "./Models/Report";
import {
  PARENT_ROLES_AMOUNT_ENDPOINT,
  PRIVILEGES_AMOUNT_ENDPOINT,
  SUB_ROLES_AMOUNT_ENDPOINT,
  getRequest,
} from "../../ApiService";
import ErrorMessage from "../../components/ErrorMessage/ErrorMessage";

const ReportsPage = () => {
  const [selected, setSelected] = useState(PARENT_ROLES.toLowerCase());
  const [isErrorMessageOpen, setIsErrorMessageOpen] = useState(false);

  const handleSelected = (newSelected: any) => {
    if (newSelected !== null) {
      setSelected(newSelected);
    }
  };

  const [parentRolesReports, setParentRoleReport] = useState<Report[]>([]);

  const [subRolesReports, setSubRoleReport] = useState<Report[]>([]);

  const [privilegesReports, setPrivilegeReport] = useState<Report[]>([]);

  useEffect(() => {
    if (selected === PARENT_ROLES.toLowerCase()) {
      getParentRoleReport();
    } else if (selected === SUB_ROLES.toLowerCase()) {
      getSubRoleReport();
    } else if (selected === PRIVILEGES.toLowerCase()) {
      getPrivilegeReport();
    }
  }, [selected]);

  const getParentRoleReport = async (searchValue?: string) => {
    try {
      await getRequest(PARENT_ROLES_AMOUNT_ENDPOINT, searchValue ?? "").then(
        (fetchedParentRoles: Report[]) => {
          setParentRoleReport(fetchedParentRoles);
        }
      );
    } catch (error) {
      setIsErrorMessageOpen(true);
    }
  };

  const getSubRoleReport = async (searchValue?: string) => {
    try {
      await getRequest(SUB_ROLES_AMOUNT_ENDPOINT, searchValue ?? "").then(
        (fetchedSubRoles: Report[]) => {
          setSubRoleReport(fetchedSubRoles);
        }
      );
    } catch (error) {
      setIsErrorMessageOpen(true);
    }
  };

  const getPrivilegeReport = async (searchValue?: string) => {
    try {
      await getRequest(PRIVILEGES_AMOUNT_ENDPOINT, searchValue ?? "").then(
        (fetchedPrivileges: Report[]) => {
          setPrivilegeReport(fetchedPrivileges);
        }
      );
    } catch (error) {
      setIsErrorMessageOpen(true);
    }
  };

  return (
    <>
      <ViewSelector
        value={selected}
        onChange={(event, newSelected) => handleSelected(newSelected)}
        exclusive
        views={[PARENT_ROLES, SUB_ROLES, PRIVILEGES]}
      />

      <ErrorMessage
        isOpen={isErrorMessageOpen}
        primaryText={ERROR_TITLE}
        additionalText={ERROR_MESSAGE}
        onClose={() => setIsErrorMessageOpen(false)}
      ></ErrorMessage>

      <Paper>
        <>
          {selected === PARENT_ROLES.toLowerCase() ? (
            <React.Fragment>
              <Box display="flex" justifyContent="space-between">
                <Searchbar
                  placeholder={PARENT_ROLE_SEARCH}
                  onChange={getParentRoleReport}
                />
              </Box>

              <List>
                {parentRolesReports.map((name, index) => (
                  <ReportItem key={index} {...name}></ReportItem>
                ))}
              </List>
            </React.Fragment>
          ) : selected === SUB_ROLES.toLowerCase() ? (
            <React.Fragment>
              <Box display="flex" justifyContent="space-between">
                <Searchbar
                  placeholder={SUB_ROLE_SEARCH}
                  onChange={getSubRoleReport}
                />
              </Box>

              <List>
                {subRolesReports.map((name, index) => (
                  <ReportItem key={index} {...name}></ReportItem>
                ))}
              </List>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Box display="flex" justifyContent="space-between">
                <Searchbar
                  placeholder={PRIVILEGE_SEARCH}
                  onChange={getPrivilegeReport}
                />
              </Box>

              <List>
                {privilegesReports.map((name, index) => (
                  <ReportItem key={index} {...name}></ReportItem>
                ))}
              </List>
            </React.Fragment>
          )}
        </>
      </Paper>
    </>
  );
};

export default ReportsPage;
